export default "__VITE_ASSET__BDZ9_iDd__"